// extracted by mini-css-extract-plugin
export default {"anchor":"progress_anchor__qYl5U","bar":"progress_bar__7EZ8d"};